import { LogBox, Platform } from 'react-native';
import { CanvasKitJS } from './src/canvaskit';
import './global.css';

if (Platform.OS === 'web') {
  (global as any).tslib = {
    __extends: () => {},
  };
}

if (__DEV__) {
  LogBox.ignoreLogs(['"transform" style array value is deprecated.']);
} else {
  LogBox.ignoreAllLogs();
}

(global as any).CanvasKit = CanvasKitJS.getInstance();

import 'expo-router/entry';
